module.exports = __webpack_public_path__ + "img/user2.0b4b8fa4.svg";